import React from 'react';

interface NeckRotateProps {}

export function NeckRotate(props: Readonly<NeckRotateProps>) {
	return (
		<svg width={90} height={60} viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M36.6523 21.7012L60.9316 36.2363" stroke="#445662" strokeDasharray="1.5 2" />
			<path
				fill="#445662"
				d="M63.5465 8.80187L63.1621 58.8846C65.0065 59.05 66.4936 57.3602 66.5119 55.0345L66.5749 47.0235L66.5937 47.0225L66.8315 13.5766C66.8485 11.2497 65.3894 9.1493 63.5465 8.80187Z"
			/>
			<path d="M21.082 7.28906L21.082 32.2754" stroke="#7F7F7F" strokeWidth={7.7} strokeLinecap="round" />
			<ellipse
				cx={18.6831}
				cy={8.26497}
				rx={18.6831}
				ry={8.26497}
				fill="#7F7F7F"
				transform="matrix(-0.00683187 0.999977 -0.999967 -0.00819002 30.4766 1.04102)"
			/>
			<circle cx={25.1558} cy={19.7875} r={8.96526} transform="rotate(90 25.1558 19.7875)" fill="#999999" />
		</svg>
	);
}
